/**
 * Get table Data
 */
export const tableData = (state) => {
    let chartData = state.dayOneAssessmentResults.scatter.data;
    let type = state.dayOneAssessmentResults.scatter.labels.type;

    let data = [];

    if (Object.keys(chartData).length) {
        for (let gender in chartData) {
            for (let index = 0; index < chartData[gender].length; index++) {
                data.push(chartData[gender][index]);
            }
        }
    }

    return data;
};


// WEBPACK FOOTER //
// ./src/store/modules/shared/tableData.js